<!--- Start Header --->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!--- End Header --->

<!--- Start Body with Tabs --->
<div class="modal-body" [hidden]="minimise">
  
  <!-- Tab Navigation -->
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li 
        [class.active]="tab.id === activeTab"
        role="presentation">
      <a (click)="activeTab = tab.id" 
         style="cursor: pointer;"
         class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">
    <!-- Form Entry Tab (from F8916Entry.html) -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
              @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      
      @if (!showFormLoader) {
<div>
          <!-- Entity information table -->
          <table class="table table-bordered form-inline enityDetails custom-table">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.key }}</span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>
          
          <!-- Main Form Table -->
          <table class="I_Entry table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="10">{{ modalTitle }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of f8916FormView.rows; track itemTracker(row)) {
<tr class="formDataBlock">
                <td>{{ row.num }}</td>
                <td class="descBlock">
                  <span>{{ row.description }}</span>
                </td>
                <td align="right">
                  <input 
                    type="text" 
                    [disabled]="row.is_editable === 'N'" 
                    [(ngModel)]="row.value" 
                    [name]="row.num" 
                    (ngModelChange)="validateLines(row)"
                    onlyDigitsDecimal
                    class="form-control input-sm">
                </td>
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!--- Start Footer --->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div> 